import { Routes, Route } from "react-router-dom";
import AppConfiguration from "./components/appconfiguration";
import Login from "./components/login";
import Unauthorized from "./components/unauthorized";
import Navbar from "./components/navbar";
import SolanaWalletGenerator from "./components/solanawalletgenerator";

function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route element={<Navbar />}>
                    <Route path="/solanawalletgenerator" element={<SolanaWalletGenerator />} />
                    <Route path="/appconfiguration" element={<AppConfiguration />} />
                </Route>
            </Routes>
        </div>
    );
}

export default App;
